/**
 * The model for the Retail /Account/Option/:id REST endpoint
 */
import RetailModel from 'app/src/data/models/RetailModel';
import URLHelper from 'app/src/data/models/utils/URLHelper';
import Format from 'app/src/data/Format';

export default class Option extends RetailModel {
  // Server uses the optionID field as the model's unique identifier. This
  // informs the Backbone.Model of this fact.
  get idAttribute() {
    return 'optionID';
  }

  get defaults() {
    return {
      name: '',
      value: '',
      timestamp: '',
      dataType: '',
    };
  }

  /**
   * Return the url for the Sale endpoint
   */
  url() {
    let URL = URLHelper.getAccountURL('/Option');
    if (!this.isNew()) {
      URL += `/${this.id}`;
    }
    return `${URL}.json`;
  }

  /**
   * Overridden to parse out the superfluous json that the LSCloud returns us
   * @param response - the json object returned from the fetch call before this object has initialized from it
   * @returns {*} the json object that this object will initialize itself from
   */
  parse(response) {
    let parsedResponse;
    // trim out wonky stuff from the response which is present if we fetch a single model
    // but not if it's coming from a collection
    if (response.Option) {
      parsedResponse = response.Option;
    } else {
      parsedResponse = response;
    }

    return parsedResponse;
  }
}
